import type { Theme } from '../types';
import { Leaves } from './Leaves';

// Dino / jungle — deep green canopy with floating leaves.
export const dinoTheme: Theme = {
  key: 'dino',
  name: 'Dinosaurus',
  tokens: {
    bodyBackground: 'linear-gradient(180deg, #166534 0%, #65a30d 60%, #a3e635 100%)',
    pageHeadingColor: '#ffffff',
    pageHeadingShadow: '0 4px 0 rgba(20, 83, 45, 0.6)',
    routineCardSurface: 'rgba(255, 255, 255, 0.6)',
    cardSurface: 'rgba(255, 255, 255, 0.85)',
    accent: '#65a30d',
  },
  decoration: { kind: 'component', component: Leaves },
  routineCardPalette: ['#fbbf24', '#fb923c', '#a3e635', '#fb7185', '#facc15', '#fde68a'],
};
